/* eslint-disable react-hooks/rules-of-hooks */
import { useState, useEffect } from 'react'
import { useRoutes, useLocation, useNavigate } from 'react-router-dom'
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap'
import cn from 'classnames'
import s from './Tabs.scss'
import '!style-loader!css-loader!styles/overrides/reactstrap.css' // eslint-disable-line
import qs from 'query-string'
import isEqual from 'lodash/isEqual'

const Tabs = ({
  activeTabKey,
  withUpdateUrl,
  isSecondaryTab,
  withRoutes,
  keepState,
  tabs,
  className,
  noPadding,
  restricted,
  restrictedCb,
  contentClassName
}) => {
  const [activeTab, setActiveTab] = useState(activeTabKey)
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    withUpdateUrl && (isSecondaryTab ? updateSecondaryTabQueryParam() : updateTabQueryParam())
    withRoutes && setActiveTab(activeTab)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab])

  useEffect(() => {
    setActiveTab(activeTabKey)
  }, [activeTabKey])

  const toggle = tab => {
    if (activeTab !== tab) {
      setActiveTab(tab)
    }
  }

  const updateTabQueryParam = () => {
    const queryParams = qs.parse(location.search)

    if (queryParams.tab === activeTab) return

    navigate({
      search: `?tab=${activeTab}`
    })
  }

  const updateSecondaryTabQueryParam = () => {
    const queryParams = qs.parse(location.search)
    const newQueries = { ...queryParams, secondaryTab: activeTab }

    if (isEqual(queryParams, newQueries)) return

    navigate({ search: qs.stringify(newQueries) })
  }

  const getTabContent = tabs => {
    return tabs
      .filter(tab => tab.disabled === undefined || !tab.disabled)
      .map(tab => {
        if (keepState) {
          return (
            <TabPane
              style={activeTab === tab.key ? {} : { display: 'none' }}
              key={tab.key}
              tabId={tab.key}
            >
              {tab.value}
            </TabPane>
          )
        } else {
          return (
            <TabPane key={tab.key} tabId={tab.key}>
              {activeTab === tab.key ? tab.value : null}
            </TabPane>
          )
        }
      })
  }
  return (
    <div className={cn(s.tabsWrapper, className)}>
      <Nav tabs>
        {tabs
          .filter(tab => tab.disabled === undefined || !tab.disabled)
          .map(tab => (
            <NavItem key={tab.key} data-cy={tab.key}>
              <NavLink
                className={cn({ active: activeTab === tab.key })}
                onClick={() => {
                  if (restricted) {
                    restrictedCb && restrictedCb()
                    return
                  }

                  if (withRoutes) {
                    navigate(tab.path)
                  } else {
                    toggle(tab.key)
                  }
                  tab.cb && tab.cb()
                }}
              >
                {tab.label}
              </NavLink>
            </NavItem>
          ))}
      </Nav>
      <TabContent
        activeTab={activeTab}
        className={cn({ [s.noPadding]: noPadding, [contentClassName]: contentClassName })}
      >
        {withRoutes
          ? useRoutes([
              ...tabs
                .filter(t => t.index)
                .map(t => ({
                  index: true,
                  element: t.element
                })),
              ...tabs
            ])
          : getTabContent(tabs)}
      </TabContent>
    </div>
  )
}

export default Tabs
